// src/elements/Validation/constants.ts
var VALIDATION_ICON_MAP = {
  success: "circle-check",
  warning: "exclamation",
  info: "info",
  error: "exclamation",
  dim: "info"
};
export { VALIDATION_ICON_MAP };